import {Component, HostBinding, Input, OnDestroy, OnInit} from '@angular/core';
import {routeAnimation} from '../../../../route.animation';
import {PreviousUrlService} from '../../../../_services/previous-url.service';
import {ReportsComments} from '../../../../_interfaces/reports/reports-comments';
import {ReportsService} from '../../../../_services/reports.service';
import {GeneralService} from '../../../../_services/general.service';
import {Subscription} from 'rxjs/Subscription';
import {ActivatedRoute, Params} from '@angular/router';
import {AuthenticationService} from '../../../../_services/authentication.service';
import {User} from '../../../../_interfaces/user';
import {ServerResponse} from '../../../../_interfaces/server.response';
import {ApiService} from '../../../../_interceptors/api.service';
import {PageTitleService} from '../../../../_services/page-title.service';
import {environment} from '../../../../../environments/environment';

@Component({
	selector: 'app-reports-closed-comments-list',
	templateUrl: './reports-comments-list.component.html',
	styleUrls: ['./reports-comments-list.component.scss'],
	animations: [routeAnimation]
})

export class ReportsClosedCommentsListComponent implements OnInit, OnDestroy {

	@HostBinding('@routeAnimation') routerTransition = true;

	private totalItems: number = 0;
	private currentPage: number = 0;
	private searchString: string = '';
	private isLoading: boolean = false;
	private keepLoading: boolean = false;

	public report_type: string = null;
	public report_id: number = null;
	public report_status: string = '/closed';
	public reportComments: ReportsComments[] = [];

	private _activatedRouteSubscription: Subscription = null;
	private _authenticationServiceSubscription: Subscription = null;

	@Input() smallWidget: boolean = false;
	@Input() reportEditable: boolean = false;
	public user: User = null;

	constructor(private reportsService: ReportsService,
				private apiService: ApiService,
				private previousUrlService: PreviousUrlService,
				private authenticationService: AuthenticationService,
				private activatedRoute: ActivatedRoute,
				private generalService: GeneralService,
				private pageTitleService: PageTitleService) {
	}

	ngOnInit(): void {
		this._activatedRouteSubscription = this.activatedRoute.params.subscribe((params: Params) => {
			this.report_type = params['report_type'];
			this.report_id = parseInt(params['report_id'], 10);

			if (this.smallWidget === false) {
				this.reportsService.getClosedReports(this.report_type, this.report_id).then((data: ServerResponse) => {
					if (typeof data !== 'undefined') {
						if (typeof data[0] !== 'undefined') {
							this.pageTitleService.setTitle(data[0].report_nr + ' | Rapportage opmerking | ' + environment.webappName);
							this.pageTitleService.setPageTitle(data[0].report_nr);
						}
					}
				});
			}

			this._authenticationServiceSubscription = this.authenticationService.user.first().subscribe(user => {
				this.user = user;
				this.currentPage = 0;
				this.getComments(false);
			});
		});
	}

	ngOnDestroy(): void {
		if (this._authenticationServiceSubscription !== null) {
			this._authenticationServiceSubscription.unsubscribe();
		}
	}

	getComments(append_data: boolean = true) {
		if (!this.isLoading || this.keepLoading) {
			this.isLoading = true;
			this.keepLoading = false;
			this.currentPage++;

			this.reportsService.getClosedReportComments(this.report_type, this.report_id, null, {
				start: (this.currentPage - 1) * (this.smallWidget ? this.generalService.itemsPerPageShort : this.generalService.itemsPerPage),
				length: (this.smallWidget ? this.generalService.itemsPerPageShort : this.generalService.itemsPerPage),
				'columns[0][search][value]': this.searchString
			}).then((data: ServerResponse) => {
				if (typeof data !== 'undefined') {
					if (typeof data.recordsTotal !== 'undefined') {
						this.totalItems = data.recordsTotal;
					}
					if (append_data === true) {
						this.reportComments.push(...<ReportsComments[]>data.data);
					} else {
						this.reportComments = <ReportsComments[]>data.data;
					}
				}
				this.isLoading = false;
			});
		}
	}

	search($event) {
		this.searchString = $event;
		this.currentPage = 0;
		this.getComments(false);
	}
}
